"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sf = exports.WrappedMap = exports.Map = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _api = require("@react-google-maps/api");
var _MapMarker = require("../MapMarker");
var _styles = require("./styles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; } // @ts-nocheck
/** A Map component wrapper for the Google Map API that renders chargers. */
var Map = function Map(_ref) {
  var className = _ref.className,
    _ref$setCenter = _ref.setCenter,
    setCenter = _ref$setCenter === void 0 ? function () {} : _ref$setCenter,
    googleMapURL = _ref.googleMapURL,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? {
      latitude: '',
      longitude: ''
    } : _ref$position,
    styles = _ref.styles,
    _ref$onDrag = _ref.onDrag,
    onDrag = _ref$onDrag === void 0 ? function () {} : _ref$onDrag,
    _ref$onZoom = _ref.onZoom,
    onZoom = _ref$onZoom === void 0 ? function () {} : _ref$onZoom,
    options = _ref.options,
    forwardedRef = _ref.forwardedRef,
    searchBox = _ref.searchBox,
    clusterInfoWindow = _ref.clusterInfoWindow,
    _ref$onOpenCluster = _ref.onOpenCluster,
    onOpenCluster = _ref$onOpenCluster === void 0 ? function () {} : _ref$onOpenCluster,
    markers = _ref.markers,
    dataTestId = _ref['data-testid'];
  var _useState = (0, _react.useState)({}),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    statePosition = _useState2[0],
    setStatePosition = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    openClusterWindow = _useState4[0],
    setOpenClusterWindow = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    idled = _useState6[0],
    setIdled = _useState6[1];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var searchBoxRef = (0, _react.useRef)();
  var onPlacesChanged = function onPlacesChanged() {
    var places = searchBoxRef.current.getPlaces();
    setCenter(places[0].geometry.location);
  };
  /** Closes openClusterWindow */
  var closeClusterWindow = function closeClusterWindow() {
    setOpenClusterWindow(false);
    setStatePosition({});
  };
  /** Checks for clusters and makes request to get contained sites */
  var onClusterClick = function onClusterClick(clusterer) {
    if (clusterer.map.zoom === 22 && clusterer.markerClusterer.clusters.length) {
      var center = clusterer.center;
      if (center) {
        var centerLat = parseFloat(center.lat());
        var centerLng = parseFloat(center.lng());
        var coords = {
          neLat: Number((centerLat + 0.0000045).toFixed(7)),
          neLng: Number((centerLng + 0.0000045).toFixed(7)),
          centerLat: centerLat,
          centerLng: centerLng,
          swLat: Number((centerLat - 0.0000045).toFixed(7)),
          swLng: Number((centerLng - 0.0000045).toFixed(7))
        };
        var inputs = {
          page: 0,
          pageSize: 999,
          filter: _objectSpread({}, coords)
        };
        onOpenCluster({
          variables: {
            sitesInput: inputs
          }
        });
        setOpenClusterWindow(true);
        setStatePosition({
          lat: center.lat(),
          lng: center.lng()
        });
      }
    }
  };
  var clusterImgUrl = 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m';
  return /*#__PURE__*/_react["default"].createElement(_styles.Styled, {
    googleMapsApiKey: googleMapURL
  }, /*#__PURE__*/_react["default"].createElement(_api.GoogleMap, {
    id: "map",
    center: {
      lat: position.latitude,
      lng: position.longitude
    },
    onDragEnd: function onDragEnd() {
      onDrag();
      closeClusterWindow();
    },
    onIdle: function onIdle() {
      if (!idled) setIdled(true);
    },
    onZoomChanged: onZoom,
    options: options,
    mapContainerStyle: styles,
    ref: forwardedRef,
    zoom: 14,
    "data-testid": dataTestId
  }, searchBox && searchBox.show && /*#__PURE__*/_react["default"].createElement(_api.StandaloneSearchBox, {
    onPlacesChanged: onPlacesChanged,
    ref: searchBoxRef
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: className,
    type: "text",
    placeholder: searchBox.placeholder
  })), openClusterWindow && clusterInfoWindow && /*#__PURE__*/_react["default"].createElement(_api.InfoWindow, {
    position: statePosition,
    onCloseClick: function onCloseClick() {
      return closeClusterWindow();
    }
  }, clusterInfoWindow), /*#__PURE__*/_react["default"].createElement(_api.MarkerClusterer, {
    options: {
      imagePath: clusterImgUrl
    },
    averageCenter: true,
    gridSize: forwardedRef && forwardedRef.current && forwardedRef.current.state.map.zoom > 18 ? 200 : 60,
    onClick: function onClick(clusterer) {
      return onClusterClick(clusterer);
    }
  }, function () {
    return markers.map(function (marker, i) {
      return /*#__PURE__*/_react["default"].createElement(_MapMarker.MapMarker, {
        key: i
        // icon={ marker.icon }
        ,
        label: marker.label,
        open: marker.open,
        onClick: marker.onClick,
        onClose: marker.onClose,
        position: {
          lat: marker.lat,
          lng: marker.lng
        }
      }, marker.infoComponent);
    });
  })));
};
/** Wrapped component that includes Google map API info. */
exports.Map = Map;
var WrappedMap = Map;
exports.WrappedMap = WrappedMap;
var sf = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(WrappedMap, (0, _extends2["default"])({}, props, {
    forwardedRef: ref
  }));
});
exports.sf = sf;